var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41335 20H5.24858L7.86577 12.7273H9.13352L11.7507 20H10.5859L8.52983 14.0483H8.47301L6.41335 20ZM6.60866 17.152H10.3871V18.0753H6.60866V17.152ZM18.671 12.7273V20H17.6625L13.9657 14.6662H13.8983V20H12.801V12.7273H13.8166L17.5169 18.0682H17.5843V12.7273H18.671ZM22.6261 20H20.2717V12.7273H22.7006C23.4132 12.7273 24.0252 12.8729 24.5366 13.1641C25.0479 13.4529 25.4397 13.8684 25.712 14.4105C25.9866 14.9503 26.1239 15.5978 26.1239 16.353C26.1239 17.1106 25.9854 17.7616 25.7085 18.3061C25.4338 18.8506 25.0361 19.2696 24.5153 19.5632C23.9944 19.8544 23.3647 20 22.6261 20ZM21.369 19.0412H22.5657C23.1197 19.0412 23.5801 18.937 23.9471 18.7287C24.314 18.518 24.5887 18.2138 24.771 17.8161C24.9532 17.416 25.0444 16.9283 25.0444 16.353C25.0444 15.7824 24.9532 15.2983 24.771 14.9006C24.591 14.5028 24.3223 14.201 23.9648 13.995C23.6074 13.7891 23.1635 13.6861 22.6332 13.6861H21.369V19.0412Z",
    fill: "#0869FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnd);
export default __webpack_public_path__ + "static/media/and.0b0fea45f490311f3b6ee72b5a4d6a98.svg";
export { ForwardRef as ReactComponent };